// extracted by mini-css-extract-plugin
var _1 = "ActionsPopup_icon__9Whq1";
var _2 = "ActionsPopup_menu__aI0E9";
var _3 = "ActionsPopup_menuItem__t-mEk";
export { _1 as "icon", _2 as "menu", _3 as "menuItem" }
